function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState } from 'react';
import Client from '@searchkit/instantsearch-client';
import c from 'classnames';
import { Configure, InstantSearch, useInstantSearch } from 'react-instantsearch';
import Searchkit from 'searchkit';
import { DEFAULT_HITS_PER_PAGE } from '../../config/constants';

// Omit `searchClient` when extending the InstantSearchProps.
// We do that because we calculate the searchClient in this component
// and pass it to the <InstantSearch> wrapper anyways.

const AnalyticsHandler = props => {
  const {
    indexName
  } = props;
  const [previousUiState, setPreviousUIState] = useState('{}');
  const {
    uiState
  } = useInstantSearch();

  /**
   * Compare the query, menu and refinementlist with
   * The previous values as strings
   * If they differ, overwrite the previous values
   * And send an event to the dataLayer
   */
  const handleAnalyticsEvent = state => {
    var _previousState, _previousState2, _previousState3;
    const currentState = state[indexName];
    const currentQuery = currentState.query || '';
    const currentMenu = currentState.menu;
    const currentRefinementList = currentState.refinementList;
    let previousState;
    try {
      previousState = JSON.parse(previousUiState);
    } catch (_e) {
      previousState = {};
    }
    const previousQuery = ((_previousState = previousState) === null || _previousState === void 0 ? void 0 : _previousState.query) || '';
    const previousMenu = (_previousState2 = previousState) === null || _previousState2 === void 0 ? void 0 : _previousState2.menu;
    const previousRefinementList = (_previousState3 = previousState) === null || _previousState3 === void 0 ? void 0 : _previousState3.refinementList;
    if ((currentQuery !== previousQuery || JSON.stringify(currentMenu) !== JSON.stringify(previousMenu) || JSON.stringify(currentRefinementList) !== JSON.stringify(previousRefinementList)) && !(!currentQuery && !currentMenu && !currentRefinementList)) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'searchkit_search',
          searchQuery: currentQuery,
          searchFacets: JSON.stringify(currentMenu),
          searchRefinements: JSON.stringify(currentRefinementList)
        });
      }
    }
    setPreviousUIState(JSON.stringify(currentState));
  };
  useEffect(() => {
    if (uiState[indexName]) {
      handleAnalyticsEvent(uiState);
    }
  }, [uiState]);
  return null;
};
const SearchkitWrapper = props => {
  const {
    connection,
    indexName,
    searchSettings,
    requestOptions = {},
    routing = false,
    analytics = false,
    className,
    onlyFetchWithQuery,
    children,
    hitsPerPage = DEFAULT_HITS_PER_PAGE,
    ...restProps
  } = props;
  const classNames = c('Searchkit', className);
  const searchClient = React.useMemo(() => {
    const sk = new Searchkit({
      connection,
      search_settings: searchSettings
    });
    const client = Client(sk, requestOptions);
    return {
      ...client,
      search: requests => {
        const shouldSearch = requests.some(_ref => {
          let {
            params
          } = _ref;
          return (params === null || params === void 0 ? void 0 : params.query) !== '' && (params === null || params === void 0 ? void 0 : params.query) !== undefined || !onlyFetchWithQuery;
        });
        if (shouldSearch) {
          return client.search(requests);
        }
        return Promise.resolve({
          results: [{
            hits: []
          }]
        });
      }
    };
  }, [connection, searchSettings, requestOptions, onlyFetchWithQuery]);
  const searchParameters = {};
  if (hitsPerPage > 0) {
    searchParameters.hitsPerPage = hitsPerPage;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement(InstantSearch, _extends({}, restProps, {
    indexName: indexName,
    searchClient: searchClient,
    routing: routing
  }), analytics && /*#__PURE__*/React.createElement(AnalyticsHandler, {
    indexName: indexName
  }), /*#__PURE__*/React.createElement(Configure, searchParameters), children));
};
export default SearchkitWrapper;